import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

import {
  IDia,
  INivel,
  // IResponseObtenerMisRutinas,
  IResponseObtenerMisRutinasTotal,
  ISemana,
} from '../../Interfaces/IMisRutinas';
import { IUserFromStorage } from '../../Interfaces/IUser';
import { Tr4inerContainedButton } from '../../Utils/Button';
import { obtenerMisRutinasTotal } from '../../Services/MisRutinas';
import Loading from '../../Utils/Loading';
import GridRutinasMobile from './Mobile/GridMobile/GridRutinasMobile';
// import TitleContainer from '../../Components/TitleContainer/TitleContainer';
import ExpiredMembreship from '../../Components/ExpiredMembreship/ExpiredMembreship';

import CloseIcon from '@mui/icons-material/Close';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ModalCalentamiento from '../../Components/ModalCalentamiento/ModalCalentamiento';

import '../../Shared/css/MisRutinas/misRutinasMobile.css';


function MisRutinas() {
  
  // const [MisRutinas, setMisRutinas] = useState<IResponseObtenerMisRutinas>();
  const [isMembershipExpired, setIsMembershipExpired] = useState<boolean>(false);
  // const [currentSemanaRutinaID, setCurrentSemanaRutinaID] = useState<number>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isOpenModalCalentamiento, setIsOpenModalCalentamiento] = useState<boolean>(false);

  const [linkCardioConImpacto, setLinkCardioConImpacto] = useState<string | undefined>()
  const [linkCardioSinImpacto, setLinkCardioSinImpacto] = useState<string | undefined>()
  const [linkCalentamientoVideo, setLinkCalentamientoVideo] = useState<string | undefined>()
  const [goal, setGoal] = useState<string | undefined>()

  const [daysAmount, setDaysAmount] = useState<number>(3);
  const [currentWeek, setCurrentWeek] = useState<number>(1);
  // const [currentOrderRoutine, setCurrentOrderRoutine] = useState<number>(1);
  // const [currentPhaseString, setCurrentPhaseString] = useState<string>('Nivel 1');
  const [initialPhaseString, setInitialPhaseString] = useState<string>('Nivel 1');

  const [niveles, setNiveles] = useState<INivel[]>([]);
  const [currentPhasePosition, setCurrentPhasePosition] = useState<number>(0);
  const [phaseRoutine, setPhaseRoutine ] = useState<INivel | null>(null);


  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const user : IUserFromStorage = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    setCurrentPhasePosition(-1);    
    if(user) {
      obtenerMisRutinasTotal({
        usuarioTestAsesoriaID: Number(user.usuarioTestAsesoriaID)
      })
        .then((response) => {
          if(response.data.status === 200 ) {
            if(response.data.data) {

              const { nivel, descanso, semana, niveles, ordenActual, cantidadDias, linkCardioConImpacto, linkCardioSinImpacto, objetivo, linkCalentamiento } : IResponseObtenerMisRutinasTotal = response.data.data;

              // setCurrentPhaseString(nivel);
              setInitialPhaseString(nivel);
              setCurrentWeek(semana);
              // setCurrentOrderRoutine(ordenActual);
              setDaysAmount(cantidadDias);
              setLinkCardioConImpacto(linkCardioConImpacto);
              setLinkCardioSinImpacto(linkCardioSinImpacto);
              setLinkCalentamientoVideo(linkCalentamiento);
              setGoal(objetivo);
              setPhaseRoutine(null);
              setNiveles([]);

              if (niveles?.length > 0) {

                const temporaryNiveles = niveles.map((nivel : INivel) => ({
                  ...nivel,
                  semanas: nivel.semanas.map((semana : ISemana) => ({
                    ...semana,
                    nivel: nivel.nombre,
                    nivelString: nivel.nombre.replace('Nivel ', ''),
                  }))
                }))

                setNiveles(temporaryNiveles);

                // Buscamos el nivel actual
                const nivelActual = temporaryNiveles.find((n: INivel) => n.nombre === nivel) || temporaryNiveles[0];
                if(localStorage.getItem('semanas')){
                  localStorage.removeItem('semanas');
                }
                if(localStorage.getItem('currentOrdenFinalizado')){
                  localStorage.removeItem('currentOrdenFinalizado');
                }
                localStorage.setItem('currentOrdenFinalizado', JSON.stringify(ordenActual));
                localStorage.setItem('semanas', JSON.stringify(nivelActual.semanas));
                //seteamos el descanso de las rutinas
                localStorage.setItem('descanso', descanso);
                setPhaseRoutine(nivelActual);
                setCurrentPhasePosition(temporaryNiveles.indexOf(nivelActual));
                // expandPanel(`panel${semana}-${nivelActual.nombre}`);
              }
            } else {
              setPhaseRoutine(null);
            }

          } else {
            setIsMembershipExpired(true);
          }
        })
        .catch(console.error)
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [])

  useEffect(() => {
    const nivelActual = niveles[currentPhasePosition];
    // setCurrentPhaseString(nivelActual ? nivelActual.nombre : 'Nivel 1');
    setPhaseRoutine(nivelActual);
    if (nivelActual && nivelActual.nombre === initialPhaseString) {
      expandPanel(`panel${currentWeek}-${initialPhaseString}`);
      // console.log(currentWeek, 'Current Week Expanded');
    } else {
      expandPanel(`panel${nivelActual?.semanas[0]?.numeroSemana}-${nivelActual?.nombre}`);
    }
  }, [currentPhasePosition])

  // useEffect(() => {
  //   console.log(currentPhaseString, 'Current Phase');
  //   console.log(currentWeek , currentPhaseString, 'Current Week and phase');
  //   console.log(currentOrderRoutine, 'Current Order Routine');
  //   console.log(phaseRoutine, 'Phase Routine');
  // }, [currentPhaseString,currentWeek,currentOrderRoutine,phaseRoutine])

  const selectPreviousPhase = () => {
    if (currentPhasePosition !== 0) {
      setCurrentPhasePosition((c) => c - 1);
    } else {
      navigate('/producto/2');
    }
  };

  const selectNextPhase = () => {
    if(currentPhasePosition !== niveles.length - 1) {
      setCurrentPhasePosition((c) => c + 1);
    } else {
      navigate('/producto/2');
    }
  }

  const obtenerRutinaEjercicio = (dia: IDia, semana: ISemana) => {
    if (localStorage.getItem('currentDiaSelected')) {
      localStorage.removeItem('currentDiaSelected');
    }
    if (localStorage.getItem('currentSemanaSelected')) {
      localStorage.removeItem('currentSemanaSelected');
    }
    localStorage.setItem('currentDiaSelected', JSON.stringify(dia));
    localStorage.setItem('currentSemanaSelected', JSON.stringify(semana));
    console.log(dia, semana, 'obtener Ejercicio');
    navigate('/ejercicioRutina');
  };

  const styles = {
    grid: {
      gridTemplateColumns:
        phaseRoutine &&
        phaseRoutine.semanas &&
        phaseRoutine.semanas.length > 0 &&
        `repeat(${phaseRoutine.semanas[0].dias.length + 1}, minmax(0, 1fr))`,
    },
    largeSpanDiasCardio: {
      gridColumn: `span ${daysAmount}`,
    },
  };

  const handleCardios = (
    linkCardioConImpacto: string,
    linkCardioSinImpacto: string,
    objetivo: string,
    cantidadDias: number,
  ) => {
    const cardioData = {
      linkCardioConImpacto,
      linkCardioSinImpacto,
      objetivo,
      cantidadDias,
    };

    // Guardar en localStorage
    localStorage.setItem('cardioData', JSON.stringify(cardioData));
    window.scrollTo(0, 0);
    // Navegar a la nueva ruta
    navigate('/cardioRutinas');
  };

  const [expanded, setExpanded] = useState<string | false>('');
  // const [mostrarVideo, setMostrarVideo] = useState<boolean>(false);

  const expandPanel = (panel: string) => {
    // console.log(panel, 'Panel that should be expanded function xd');
    setExpanded(expanded === panel ? false : panel);
  };

  const handleChange = (panel: string) => (event: SyntheticEvent, newExpanded: boolean) => {
    // console.log(panel, 'Panel that should be expanded event xd');
    setExpanded(newExpanded ? panel : false);
  }
  // console.log(MisRutinas);

  return (
    <>
      {isLoading ? (
        <div className="h-[100dvh] flex items-center justify-center">
          <Loading />
        </div>
      ) : ( 
        <>
          {!isMembershipExpired ? (
            phaseRoutine ? (
              <div className={isMobile ? "misrut-page" : "w-full flex flex-col"}>
                {isMobile ? (
                  <>
                    {/* Mobile Phase Navigation */}
                    <div className="misrut-phase-nav">
                      <button
                        className="misrut-nav-btn"
                        onClick={selectPreviousPhase}
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          {currentPhasePosition === 0 ? (
                            <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>
                          ) : (
                            <polyline points="15 18 9 12 15 6" />
                          )}
                        </svg>
                      </button>

                      <span className="misrut-phase-title">
                        {phaseRoutine.nombre || 'Tus Rutinas'}
                      </span>

                      <button
                        className="misrut-nav-btn"
                        onClick={selectNextPhase}
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          {currentPhasePosition === niveles.length - 1 ? (
                            <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>
                          ) : (
                            <polyline points="9 18 15 12 9 6" />
                          )}
                        </svg>
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="h-[5vh] w-full"></div>
                    {/* Desktop Phase Navigation - unchanged */}
                    <div className="w-full flex flex-row justify-around md:mt-4">
                      <div>
                        <button
                          onClick={selectPreviousPhase}
                          title={currentPhasePosition === 0 ? 'Salir' : 'Mes anterior'}
                        >
                          {currentPhasePosition === 0 ? (
                            <CloseIcon fontSize="large" />
                          ) : (
                            <ArrowBackIosIcon fontSize="large" />
                          )}
                        </button>
                      </div>
                      <div>
                        <p className='md:block mb-0 text-[1.6rem] font-bold text-red-600'>
                          {phaseRoutine.nombre || 'Tus Rutinas'}
                        </p>
                      </div>
                      <div>
                        <button
                          onClick={selectNextPhase}
                          title={currentPhasePosition === niveles.length - 1 ? 'Salir' : 'Siguiente mes'}
                        >
                          {currentPhasePosition === niveles.length - 1 ? (
                            <CloseIcon fontSize="large" />
                          ) : (
                            <ArrowForwardIosIcon fontSize="large" />
                          )}
                        </button>
                      </div>
                    </div>
                  </>
                )}
                {/* <div
                  className='h-[1.5px] md:w-[75%] w-[80%] mt-10 bg-black opacity-40 self-center'
                ></div> */}
                <div className="md:ml-4 flex flex-col w-full md:w-[60%] mx-auto">
                  <div className="m-auto w-[90%]">
                    {/* Descripcition  */}
                    <section className="hidden md:block">
                      <p className="subtitle">Tus rutinas</p>
                      <p className="text-sm text-slate-700 text-left">
                        Este es un desglose detallado de las rutinas de ejercicio, organizadas y
                        presentadas semana por semana para una fácil referencia y seguimiento
                        👌🏼.
                      </p>
                    </section>
                    {/* Fase */}
                    {/* {!isMobile &&  (
                      <p className='md:block mb-0 text-[1.6rem] font-bold text-red-600'>
                        { currentPhase ? currentPhase : ''}
                      </p>
                    )} */}
                    {/* Grid */}
                    <div className="w-full m-auto text-[10px] md:text-sm">
                      {/* grid */}
                      {phaseRoutine.semanas && phaseRoutine.semanas.length > 0 && (
                        <section>

                          {!isMobile ? (
                            phaseRoutine.semanas.map((semana, index) => (
                              <div className={`grid gap-2 mb-2`} key={index}>
                                <Accordion
                                  // defaultExpanded={
                                  //   (semana.numeroSemana === currentWeek && semana.nivel === currentPhaseString) && true 
                                  // }
                                  expanded={expanded === `panel${semana.numeroSemana}-${semana.nivel}`}
                                  aria-description={`panel${semana.numeroSemana}-${semana.nivel}`}
                                  onChange={handleChange(`panel${semana.numeroSemana}-${semana.nivel}`)}
                                  style={{ boxShadow: 'none' }}
                                >
                                  <AccordionSummary style={{ padding: 0 }}> 
                                    <div
                                      className={`font-extrabold uppercase bg-black text-white flex items-center justify-center rounded-xl p-3 w-full`}
                                    >
                                      {semana.semana}
                                    </div>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    
                                    {/* { user.usuarioTestAsesoriaID === 18 && ( */}
                                      <div
                                        className={`font-extrabold uppercase bg-orangeTr4iner text-black flex items-center gap-2 justify-center rounded-xl p-2 mb-2 w-full cursor-pointer`}
                                        onClick={() => setIsOpenModalCalentamiento(true)}
                                      >
                                        Calentamiento <PlayCircleIcon className='self-center' />
                                      </div>
                                    {/* )} */}

                                    <div className="flex gap-2 justify-evenly">
                                      {phaseRoutine.semanas[index].dias.map(
                                        (dia, indexDia) => (
                                          <div
                                            className="flex flex-col gap-2 w-full"
                                            key={indexDia}
                                          >
                                            <div
                                              className="bg-yellowTr4iner py-2 rounded-xl font-extrabold uppercase"
                                              key={index}
                                            >
                                              {dia.diaString}
                                            </div>
                                            <div
                                              className={`uppercase bg-[#C6C6C6] rounded-xl py-3 cursor-pointer flex flex-col gap-1 h-full items-center justify-center `}
                                              onClick={() =>
                                                obtenerRutinaEjercicio(dia, semana)
                                              }
                                            >
                                              <span>
                                                {dia.estado === '2' ? (
                                                  <CheckCircleIcon sx={{ color: 'green' }} />
                                                ) : (
                                                  <CheckCircleIcon sx={{ color: '#787878' }} />
                                                )}
                                              </span>
                                              <span>{dia.diaNombre}</span>
                                            </div>
                                          </div>
                                        ),
                                      )}
                                    </div>
                                    <div className="mt-4 flex flex-col gap-3 items-center justify-center">
                                      <p className="m-0">
                                        Finaliza tus días de entrenamiento para ir progresando
                                        cada semana.
                                      </p>
                                      <p className="m-0 flex items-center">
                                        <span className="mr-1">Al finalizar saldrá </span>
                                        <CheckCircleIcon sx={{ color: 'green' }} />.
                                      </p>
                                    </div>
                                  </AccordionDetails>
                                </Accordion>
                              </div>
                            ))
                          ) : (
                            <GridRutinasMobile
                              obtenerRutinaEjercicio={obtenerRutinaEjercicio}
                              weeklyRoutines={phaseRoutine.semanas}
                              // fase={currentPhaseString}
                              setIsOpenModalCalentamiento={setIsOpenModalCalentamiento}
                              expanded={expanded}
                              handleChange={handleChange}
                            />
                          )}
                          {!isMobile && (
                            <div className={`flex w-full mb-2 gap-2`}>
                              {!isMobile && (
                                <div className="w-full text-left">
                                  <article className="flex flex-col gap-2 my-3 w-full">
                                    <p className="font-bold text-lg m-0">Tu Cardio</p>
                                    <p className="m-0">
                                      El complemento ideal para tu entrenamiento. Pulse el botón
                                      a continuación para acceder.
                                    </p>
                                  </article>
                                  <div
                                    className="bg-yellowTr4iner uppercase py-3 flex px-2 cursor-pointer w-full rounded-lg justify-center items-center gap-2"
                                    style={styles.largeSpanDiasCardio}
                                    onClick={() =>
                                      handleCardios(
                                        linkCardioConImpacto,
                                        linkCardioSinImpacto,
                                        goal,
                                        daysAmount,
                                      )
                                    }
                                  >
                                    <RemoveRedEyeIcon sx={{ color: '#3E3C41' }} />
                                    Cardio
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </section>
                      )}
                    </div>
                  </div>
                </div>
                {isOpenModalCalentamiento && (
                  <ModalCalentamiento 
                    isOpen={isOpenModalCalentamiento}
                    setIsOpen={setIsOpenModalCalentamiento} 
                    url={linkCalentamientoVideo}
                  />
                )}
    
              </div>
            ) : (
              <div className="mt-4 flex flex-col h-[70dvh] items-center justify-center p-2">
                <CalendarMonthIcon fontSize="large" />
                <h2 className="text-2xl text-slate-800 mt-4 text-center">
                  Aún no cuentas con rutinas asignadas
                </h2>
                <p className="p-2 text-sm text-gray-500 mt-4 text-center">
                  Tus rutinas asignadas se mostrarán aquí semanalmente 📆. ¡Prepárate
                  para comenzar tu viaje fitness! 💪
                </p>
                <Tr4inerContainedButton onClick={() => navigate('/')}>
                  Ir a inicio
                </Tr4inerContainedButton>
              </div>
            )
          ) : (
            <ExpiredMembreship />
          )}
        </>
      )}
    </>
  );
}

export default MisRutinas;
